import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLayout } from "../components/page-layout";
import { PageLoader } from "../components/page-loader";
import { StatusCard } from "../components/onyx/StatusCard";
import { verifyEmailChange } from "../services/backend.service";

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const { logout } = useAuth0();
  const [status, setStatus] = useState('verifying');
  const [errorMessage, setErrorMessage] = useState('');

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage('Missing verification token');
      return;
    }

    const verify = async () => {
      const { error } = await verifyEmailChange(token);
      if (error) {
        setStatus('error');
        setErrorMessage(error.message || 'Verification failed');
      } else {
        setStatus('success');
        setTimeout(() => {
          logout({ logoutParams: { returnTo: window.location.origin } });
        }, 3000);
      }
    };

    verify();
  }, [token, logout]);

  if (status === 'verifying') {
    return (
      <PageLayout>
        <div className="content-layout">
          <StatusCard tone="muted">
            <PageLoader />
            <p>Verifying your new email address...</p>
          </StatusCard>
        </div>
      </PageLayout>
    );
  }

  if (status === 'error') {
    return (
      <PageLayout>
        <div className="content-layout">
          <StatusCard title="Verification Failed" tone="error">
            <p>{errorMessage}</p>
            <p className="onyx-status-card__hint">
              The link may have expired. Go to your <a href="/profile">profile</a> to request a new one.
            </p>
          </StatusCard>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <StatusCard title="Email Updated" tone="success">
          <p>Your email has been changed successfully.</p>
          <p className="onyx-status-card__hint">
            You will be redirected to log in with your new email in a moment...
          </p>
        </StatusCard>
      </div>
    </PageLayout>
  );
};
